import {useContextElement} from "../../context/Context";
import {Link} from "react-router-dom";
import React, {useEffect, useState} from "react";
import QuantitySelect from "../components/QuantitySelect";


import ProgressBarComponent from "../components/Progressbar";
import AdminSpinner from "../components/AdminSpinner";
import {useAuth} from "../../context/AuthContext";

export default function CartModal() {
    const [openTool, setOpenTool] = useState(-1);
    const { isAuthenticated, logout, openLoginModal } = useAuth();

    const {
        cartProducts,
        totalPrice,
        updateQuantity,
        removeProductFromCart,
        cartLoading,
        reloadCart,
        isAuthentica
    } = useContextElement();




    return (
        <div
            className="offcanvas offcanvas-end popup-style-1 popup-shopping-cart"
            id="shoppingCart"
        >
            <div className="canvas-wrapper">
                <div className="popup-header">
                    <span className="title">Shopping cart</span>
                    <span
                        className="icon-close icon-close-popup"
                        data-bs-dismiss="offcanvas"
                    />
                </div>
                <div className="wrap">
                    {cartLoading ? (
                        <div className="cart-modal-loading">
                            <span className="loader"></span>
                        </div>
                    ) : (
                        <>
                            <div className="tf-mini-cart-threshold">
                                <div className="text">
                                    <span className="fw-medium">You’re almost there!</span>
                                </div>

                                <div className="tf-progress-bar tf-progress-ship">
                                    <ProgressBarComponent max={75}>
                                        <i className="icon icon-car"/>
                                    </ProgressBarComponent>
                                </div>
                            </div>

                            <div className="tf-mini-cart-wrap">
                            <div className="tf-mini-cart-main">
                                    <div className="tf-mini-cart-sroll">
                                        {cartProducts.length ? (
                                            <div className="tf-mini-cart-items">
                                                {cartProducts.map((product, i) => (

                                                    <div key={i} className="tf-mini-cart-item file-delete">
                                                        <div className="tf-mini-cart-image">
                                                            <Link to={`/product-detail/${product.slug}`}>
                                                                <img
                                                                    className="lazyload"
                                                                    alt="img-product"
                                                                    src={product.coverImage}
                                                                    width={190}
                                                                    height={252}
                                                                />
                                                            </Link>
                                                        </div>
                                                        <div className="tf-mini-cart-info">
                                                            <div className="d-flex justify-content-between">
                                                                <Link
                                                                    className="title link text-md fw-medium"
                                                                    to={`/product-detail/${product.slug}`}
                                                                >
                                                                    {product.title}
                                                                </Link>
                                                                <i
                                                                    className="icon icon-close remove fs-12"
                                                                    onClick={() => removeProductFromCart(product.slug, product.variantGuid)}

                                                                />
                                                            </div>
                                                            <div className="d-flex gap-10">
                                                                <div className="text-xs">{product.size}</div>
                                                            </div>
                                                            <p className="price-wrap text-sm fw-medium">
                            <span className="new-price text-primary">
                              £{(product.price * product.quantity).toFixed(2)}
                            </span>{" "}
                                                                {product.oldPrice && (
                                                                    <span
                                                                        className="old-price text-decoration-line-through text-dark-1">
                                £
                                                                        {(product.oldPrice * product.quantity).toFixed(
                                                                            2
                                                                        )}
                              </span>
                                                                )}
                                                            </p>
                                                            <QuantitySelect
                                                                quantity={product.quantity}
                                                                setQuantity={(qty) => updateQuantity(product.slug, qty, product.variantGuid)}
                                                            />

                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        ) : (
                                            <div className="p-4">
                                                Your Cart is empty. Start adding products to cart!{" "}
                                                <Link
                                                    className="tf-btn btn-dark2 animate-btn mt-3"
                                                    href="/product-list"
                                                >
                                                    Explore Products
                                                </Link>
                                            </div>
                                        )}

                                    </div>
                                </div>
                                <div className="tf-mini-cart-bottom">
                                    <div className="tf-mini-cart-bottom-wrap">
                                        <div className="tf-cart-totals-discounts">
                                            <div className="tf-cart-total text-xl fw-medium">Total:</div>
                                            <div className="tf-totals-total-value text-xl fw-medium">
                                                £{totalPrice.toFixed(2)} GBP
                                            </div>
                                        </div>
                                        <div className="tf-cart-tax text-sm opacity-8">
                                            Taxes and shipping calculated at checkout
                                        </div>
                                        <div className="tf-mini-cart-view-checkout">
                                            <Link
                                                to={`/view-cart`}
                                                onClick={() => reloadCart()}
                                                className="tf-btn animate-btn d-inline-flex bg-dark-2 w-100 justify-content-center"
                                            >
                                                View cart
                                            </Link>
                                            {/*<Link*/}
                                            {/*    to={`/checkout`}*/}
                                            {/*    className="tf-btn btn-out-line-dark2 w-100 justify-content-center"*/}
                                            {/*>*/}
                                            {/*    <span>Check out</span>*/}
                                            {/*</Link>*/}



                                            {/*en son bu vardı*/}
                                            {/*<Link*/}
                                            {/*    to={cartProducts.length > 0 ? "/checkout" : "#"}*/}
                                            {/*    state={{ fromCheckout: true }}*/}
                                            {/*    className={`tf-btn btn-out-line-dark2 w-100 justify-content-center ${*/}
                                            {/*        cartProducts.length === 0 ? "disabled" : ""*/}
                                            {/*    }`}*/}
                                            {/*    onClick={(e) => {*/}
                                            {/*        if (cartProducts.length === 0) {*/}
                                            {/*            e.preventDefault();*/}
                                            {/*            // İstersen burada küçük bir uyarı gösterebilirsin*/}
                                            {/*            //toast.error("Your cart is empty.");*/}
                                            {/*        }*/}
                                            {/*    }}*/}
                                            {/*>*/}
                                            {/*    <span>Check out</span>*/}
                                            {/*</Link>*/}
                                            <Link
                                               to={cartProducts.length > 0 ? "/checkout" : "#"}
                                            className={`tf-btn btn-out-line-dark2 w-100 justify-content-center ${cartProducts.length === 0 ? "disabled" : ""}`}
                                            onClick={(e) => {
                                            if (!isAuthenticated) {
                                                e.preventDefault();
                                                           openLoginModal(); // 🔥 SAYFA DEĞİŞMEDEN LOGIN MODAL AÇ
                                                           sessionStorage.setItem("fromCheckout", "1"); // 🔥 FLAG SET ET
                                                return;
                                            }
                                        }}
                                            >
                                            <span>Check out</span>
                                        </Link>



                                    </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
